<template>
  <div class="review-box-component">
    <div class="box">
      <div class="pt-5 px-6 px-3-mobile">
        <div class="columns">
          <div class="column is-8">
            <h1 class="is-size-2 is-size-3-mobile has-text-weight-bold">
              Seu plano
            </h1>
          </div>
          <div class="column is-4 is-flex is-align-items-center">
            <button
                class="button is-primary tooltip-button is-right has-tooltip-multiline has-tooltip-left"
                data-tooltip="O valor final cobrado para a contratação de seu plano, expresso no boleto ou na fatura de seu cartão, poderá ser menor, devido a política tributária da Pedbot, que trabalha com retenção de alguns impostos no tomador dos serviços. Caso tenha dúvidas, contacte nossa equipe ou fale com o vendedor"
            >
              ?
            </button>
          </div>
        </div>
        <div class="columns is-fullwidth" v-if="!onlyUnique">
          <div class="column is-12">
            <steps
              ref="reviewSteps"
              :formData="formData"
              :fullWidth="true"
            ></steps>
          </div>
        </div>
        <hr class="is-fullwidth" v-if="!onlyUnique">
        <div class="columns mt-2 pt-2 is-fullwidth">
          <div class="column is-12">
            <review-extra-services
              :formData="formData"
              :steps="steps"
            ></review-extra-services>
          </div>
        </div>
        <hr class="is-fullwidth">
        <div class="columns mt-2 pt-2 is-fullwidth">
          <div class="column is-12">
            <sum-description
              :formData="formData"
              :steps="steps"
              :seasonality="seasonality"
              :onlyUnique="onlyUnique"
            ></sum-description>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Steps from "@/components/Wizard/ReviewSidebar/Steps/Index";
import SumDescription from "@/components/Wizard/ReviewSidebar/SumDescription/Index";
import ReviewExtraServices from "@/components/Wizard/ReviewSidebar/ReviewExtraServices/Index";

export default {

  name: 'review-box',

  props: {
    formData: {
      required: true,
      type: Object
    },
    seasonality: {
      type: Number,
      default: () => 12
    },
    onlyUnique: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      steps: [],
      totalExtraServicesPrice: 0
    }
  },

  components: {
    Steps,
    SumDescription,
    ReviewExtraServices
  },

  mounted () {
    this.$watch(
      () => {
        return this.$refs.reviewSteps.steps
      },
      () => {
        this.populateSteps()
      }
    )
    this.populateSteps()
    this.calculateTotalExtraServicesPrice()
  },

  methods: {
    populateSteps() {
      this.steps = this.$refs.reviewSteps.steps
    },
    calculateTotalExtraServicesPrice() {
      let total = 0
      for (const extraService of this.formData.extraServices.data) {
        total += parseFloat(extraService.price) * extraService.quantity
      }
      this.totalExtraServicesPrice = total
    }
  }

}

</script>

<style lang="scss" scoped>
.review-box-component {
  &.is-fullheight {
    height: 100%;
  }

  .box {
    background-color: white;
    box-shadow: none;
    z-index: 1030;
    margin-top: 0 !important;
    padding-top: 0 !important;

    &.is-full {
      height: 100vh;
      width: 100vw;
    }

    &.is-fixed-top {
      position: fixed;
      top: 0;
      bottom: 0;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    hr {
      border: none;
      height: 3px;
      color: #dae6ec;
      background-color: #dae6ec;
    }
  }
  
  .tooltip-button {
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    font-weight: bold;
    transition: all 0.2s ease;
    
    &:hover {
      transform: scale(1.1);
    }
  }
}

@media screen and (max-width: 768px) {
  .review-box-component {
    .box {
      margin-bottom: 2rem;
    }
    
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .px-3-mobile {
      padding-left: 0.75rem !important;
      padding-right: 0.75rem !important;
    }
    
    .tooltip-button {
      height: 1.5rem;
      width: 1.5rem;
      font-size: 0.8rem;
    }
  }
}
</style>
